/**
 * Labstep
 *
 * @module components/Entity/Sortable
 * @desc Generic component for sorting entities
 *
 * TODO Refactor class component to functional component
 */

import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { ResetPositionContainer } from 'labstep-web/containers/Position';
import React from 'react';
import type {
  EntitySortableContainerProps,
  EntitySortableProps,
  EntitySortableState,
} from './types';

export class EntitySortableComponent extends React.Component<
  EntitySortableProps,
  EntitySortableState
> {
  static defaultProps = {
    sort: 'desc',
  };

  constructor(props: EntitySortableProps) {
    super(props);
    this.state = { disabled: false };
    this.setDisabled = this.setDisabled.bind(this);
    this.setEnabled = this.setEnabled.bind(this);
    this.handleOnSuccess = this.handleOnSuccess.bind(this);
  }

  handleOnSuccess(positionSent, { response }, items) {
    this.setEnabled();
    const { entityName, resetPosition } = this.props;
    const { position } =
      response.entities[entityName][response.result];
    if (positionSent !== position) {
      resetPosition(
        entityName,
        items.map((item, index) => ({
          id: item.id,
          position: index + 1,
        })),
      );
    }
  }

  setDisabled() {
    this.setState({ disabled: true });
  }

  setEnabled() {
    this.setState({ disabled: false });
  }

  render() {
    const { entityName, render } = this.props;
    const { disabled } = this.state;

    return (
      <EntityUpdateContainer entityName={entityName}>
        {({ update }) =>
          render({
            disabled: disabled || !!this.props.disabled,
            onSortEnd: ({ position, id, items }) => {
              this.setDisabled();
              update(
                { position, id },
                {
                  onSuccess: (response) =>
                    this.handleOnSuccess(
                      position,
                      response as any,
                      items,
                    ),
                  onFail: this.setEnabled,
                },
              );
            },
          })
        }
      </EntityUpdateContainer>
    );
  }
}

export const EntitySortableContainer: React.FC<
  EntitySortableContainerProps
> = (props) => (
  <ResetPositionContainer>
    {({ resetPosition }) => (
      <EntitySortableComponent
        resetPosition={resetPosition}
        {...props}
      />
    )}
  </ResetPositionContainer>
);
